// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609070940/js/" + chunkId + "." + {"44":"df6422e6","225":"c6a1f43a","481":"ed8aae95","486":"81d37e6f","770":"97adbfef"}[chunkId] + ".0.0374165692742543.chunk.js";
};